import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';

import { EventColorByIdentifier, EventNameByIdentifier, toHhMmSs } from './chart-utils';

declare let Chart: any;
import * as moment from 'moment';


export class EventsChartComponent implements OnInit, AfterViewInit {
	 public chartCanvasElementRef = null;
	 public events = [];

	private eventsMap = {};

	public ngOnInit() {
		const startTime = this.events.length ? moment(this.events[0].happened_at) : null;
		let secondsSpent = 0;
		this.events.forEach((event, index) => {
			if (!this.eventsMap[event.identifier]) {
				this.eventsMap[event.identifier] = [];
			}

			if (index > 1) {
				secondsSpent = moment.duration( moment(event.happened_at).diff(startTime)).asSeconds();
			}
			this.eventsMap[event.identifier].push({x: secondsSpent, y: EventNameByIdentifier[event.identifier], r: 1});
		});
	}

	public ngAfterViewInit() {
		if (!this.chartCanvasElementRef || !this.chartCanvasElementRef.nativeElement) {
			return;
		}

		const data = {
			datasets: Object.keys(this.eventsMap).map((key) => {
				return {
					data: this.eventsMap[key],
					borderColor: EventColorByIdentifier[key],
					backgroundColor: EventColorByIdentifier[key],
				};
			})
		};

		const eventsChart = new Chart(this.chartCanvasElementRef.nativeElement, {
			type: 'scatter',
			data,
			options: {
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					title: {
						display: true,
						text: 'Events Timeline'
					},
					legend: { display: false },
					tooltip: {
						callbacks: {
							label: (context) => `${toHhMmSs(context.parsed.x)}, ${context.formattedValue}`
						}
					}
				},
				scales: {
					x: {
						ticks: {
							font: {
								size: 11,
							},
							callback: (value) => {
								return toHhMmSs(value);
							}
						}
					},
					y: {
						type: 'category',
						labels: ['Copy', 'Paste', 'Tab displayed', 'Tab hidden', 'Tab focus-in', 'Tab focus-out', 'Code run']
					}
				}
			}
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/shared/components/hack-results-viewer/events-chart.component.ts